import { EndPoints as DomainEndPoints } from './endpoints';

// This enum is used for all the transaction response status we get.
export enum ResultStatus {
  NoProcess = 0,
  Failure = 1,
  Abort = 2,
  Cancel = 3,
  Warning = 4,
  Information = 5,
  NoData = 6,
  Validation = 7,
  Success = 8,
}
export enum responseMessageStatus {
  info = 'info',
  warning = 'warning',
  success = 'success',
  error = 'error',
}
export enum ResponseStatus {
  success = 1,
  error = 0,
}

export enum ActivityType {
  PendingPayment = 1,
  OutstandingInvoice = 2,
  CompletedTransactions = 3,
}

/** Mirrors the API InvestmentType enum - decides the QBO route used for the PDF. */
export enum InvestmentType {
  Estimate = 1,
  Invoice = 2,
}
export enum BrooklynInvestmentStatus {
  PendingApproval = 1,
  UnderReview = 2,
  Processing = 3,
  EstimateSent = 4,
  Completed = 5,
  CancellationUnderReview = 6,
  canceled = 7,
  InvoiceSent = 8,
  InvoicePaid = 9,
  Voided = 10,
  Deleted = 11,
}
export enum TransactionsType {
  StartingBalance = 0,
  Investment = 1,
  Payment = 2,
  Transfer = 3,
  Expenses = 4,
  InternalTransfer = 5,
  Refunds = 6,
  Credits = 7,
  Deposits = 8,
}
export enum TransactionsSubType {
  InvoicePaid = 1,
  Payments = 2,
  Transfers = 3,
  Canceled = 4,
}

export enum BrooklynBillStatus {
  PendingApproval = 1,
  Processing = 2,
  Payment = 3,
  CancellationUnderReview = 4,
  canceled = 5,
  UnderReview = 6,
  Voided = 7,
}
export enum PaybevPaymentStatus {
  Schedule = 1,
  CancellationUnderReview = 2,
  canceled = 3,
  UnderReview = 4,
  Voided = 5,
}
/** Account / user role classification from API `userRoleDetails.roleType`. */
export enum RoleType {
  Internal = 0,
  Operator = 1,
  Supplier = 2,
}

// here you need to define the role which you have in project
export enum UserType {
  User = 0,
  Admin = 1,
  SuperAdmin = 2,
  Vendor = 3,
  None = 4,
  SuperTenantAdmin = 5,
}

export enum PaybevStageStatus {
  Scheduled = 1,
  PendingApproval = 2,
}

export enum PdfFileEditAction {
  View = 1,
  Rotate = 2,
  Delete = 3,
}

export enum ServiceType {
  Standard = 1,
  NextDay = 2,
}

export enum contentType {
  ResquestSend = 1,
  DonateCore = 2,
  Reports = 3,
}

export enum AssignmentUser {
  projectManager = 0,
  director = 1,
  accountManager = 2,
  executive = 3,
  seniorAccountManager = 4,
  financeManager = 5,
}

export enum PaybevInvestmentStatus {
  Confirmed = 1,
  NeedsConfirmation = 2,
  UnderReview = 3,
  Rejected = 4,
  EditDate = 5,
  CancellationUnderReview = 6,
  PastDue = 7,
  Blank = 8,
}

export enum BalanceTransferStatus {
  Processing = 1,
  InvoiceSent = 2,
  InvoicePaid = 3,
  Voided = 4,
}

export enum CustomerType
{
    QboCustomer = 0,
    SiteCustomer = 1,
    RetailCustomer = 2
}

export const EndPoints = DomainEndPoints;
